const isDebugLoggingEnabled =
  import.meta.env.DEV || import.meta.env.VITE_DEBUG_LOGS === 'true';

export function warn(...args: unknown[]): void {
  if (isDebugLoggingEnabled) {
    console.warn(...args);
  }
}

export function error(...args: unknown[]): void {
  console.error(...args);
}
